/** Match the existing server filename timestamp: yyyyMMddHHmmss. */
export function membershipPdfFilename(date = new Date()): string {
    const pad = (value: number) => String(value).padStart(2, '0');
    return `會員資料_${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}.pdf`;
}